module.exports = __webpack_public_path__ + "01f43047/img/copy-icon.408fdb2d.svg";